<template>
  <div>
    <BreadCrumb class="bread" :breads="['设备管理','提货点管理']"></BreadCrumb>
    <div class="wrap" element-loading-text="加载中">
      <div class="header">
        <span class="nameFt">提货点管理</span>
      </div>
      <div class="submit-form">
        <el-form ref="form" :inline="true" size="small" label-width="82px">
          <div class="submit-form__search">
            <el-form-item label="提货点简称">
              <el-input v-model="search.name" maxlength="30"></el-input>
            </el-form-item>
          </div>
          <div class="submit-form__operate">
            <el-form-item>
              <el-button type="primary" class="operate-button" @click="searchForm">查询</el-button>
              <el-button type="primary" class="operate-button" @click="reset">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="operate-con" v-show="$store.getters.authority({name:'pickupManage',type:'add'})">
        <el-button size="small" @click="openAdd">新增</el-button>
      </div>
      <div class="table-con">
        <el-table :data="tableList" v-loading="loading" stripe>
          <el-table-column label="序号" :index="indexMethod" type="index" align="center"></el-table-column>
          <el-table-column label="提货点简称" prop="name" align="center"></el-table-column>
          <el-table-column label="核销人" prop="verification_name" align="center"></el-table-column>
          <el-table-column label="手机" prop="verification_phone" align="center"></el-table-column>
          <el-table-column label="提货地址" prop="address" align="center" show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="是否禁用" prop="status_value" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="250px">
            <div slot-scope="scope">
              <el-button size="mini" @click="openPickup(scope.row.id)" v-show="$store.getters.authority({name:'pickupManage',type:'view'})">查看</el-button>
              <el-button size="mini" type="primary" @click="updatePickup(scope.row)" v-show="$store.getters.authority({name:'pickupManage',type:'update'})">修改</el-button>
              <el-button size="mini" type="danger" @click="deletePickup(scope.row.id)" v-show="$store.getters.authority({name:'pickupManage',type:'delete'})">删除</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationWrap">
        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
export default {
  name: "pickupManagement",
  data() {
    return {
      search: {}
    };
  },
  mixins: [listMixin],
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    getData() {
      this.getTableData(apis.goods_point, "get", this.search);
    },
    searchForm() {
      this.search.page_index = 1;
      this.getTableData(apis.goods_point, "get");
    },
    reset() {
      this.search = {};
      this.search.page_index = 1;
      this.getData();
    },
    openAdd() {
      this.$router.push({
        name: "updatePickup"
      });
    },
    updatePickup(row) {
      this.$router.push({
        path: "/index/updatePickup",
        query: Object.assign(
          {},
          {
            id: row.id
          },
          this.$route.query
        )
      });
    },
    openPickup(id) {
      this.$router.push({
        name: "updatePickup",
        query: {
          id: id,
          operate: "look"
        },
        params: this.query
      });
    },
    deletePickup(id) {
      alert.deleteAlert().then(res => {
        this.$axios.delete(apis.goods_point + "/" + id).then(res => {
          if (res.data.code === 200) {
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    }
  },
  components: {
    BreadCrumb
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/common.scss");

.submit-form {
  padding: 15px 15px 0 15px;
  position: relative;

  .el-form {
    display: flex;
  }

  .el-form-item__label {
    width: 90px;
  }

  .el-input,
  .el-select {
    width: 200px;
  }
}

.operate-con {
  padding: 15px;
  border-top: 1px solid #e1e1e1;
}

.table-con {
  border-top: 1px solid #ebeef5;
}

.submit-form__search {
  width: 200px;
  flex: 1;
}

.submit-form__operate {
  .operate-button {
    width: 90px;
  }
}
</style>
